import React from 'react';

const icons = {
  productivity: (
    <path d="M12 4L4 12M8 4H12V8M6 20H18M6 16H14M6 8V10C6 10.74 6.4 11.42 7.05 11.79L10 13.5C10.65 13.88 11.05 14.56 11.05 15.3V20" />
  ),
  support: (
    <path d="M8 10H16M8 14H13M20 11C20 15.42 16.42 19 12 19H7L4 21V11C4 6.58 7.58 3 12 3C16.42 3 20 6.58 20 11Z" />
  ),
  availability: (
    <path d="M12 7V12L15 14M20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12ZM12 2V4M12 20V22M4.93 4.93L6.34 6.34M17.66 17.66L19.07 19.07M2 12H4M20 12H22" />
  ),
  cost: (
    <path d="M12 3V21M16 7.5C16 6.12 14.21 5 12 5C9.79 5 8 6.12 8 7.5C8 8.88 9.79 10 12 10C14.21 10 16 11.12 16 12.5C16 13.88 14.21 15 12 15C9.79 15 8 13.88 8 12.5" />
  ),
  insights: (
    <path d="M5 19V11M12 19V5M19 19V9M3 19H21" />
  ),
  growth: (
    <path d="M4 16L9 11L13 15L20 8M15 8H20V13" />
  ),
  audit: (
    <path d="M10 5H7C5.9 5 5 5.9 5 7V19C5 20.1 5.9 21 7 21H17C18.1 21 19 20.1 19 19V12M10 5C10 6.1 10.9 7 12 7H14M10 5C10 3.9 10.9 3 12 3H14L19 8V12M8 14L10.5 16.5L16 11" />
  ),
  automation: (
    <path d="M9 4L5 8L9 12M15 12L19 16L15 20M14 4L10 20" />
  ),
  ai: (
    <path d="M12 4L18 7.5V16.5L12 20L6 16.5V7.5L12 4ZM9 11H9.01M12 11H12.01M15 11H15.01M9.5 14.5C10.1 13.9 11 13.5 12 13.5C13 13.5 13.9 13.9 14.5 14.5" />
  ),
  integration: (
    <path d="M8 8H4V4H8V8ZM20 8H16V4H20V8ZM8 20H4V16H8V20ZM20 20H16V16H20V20ZM8 6H16M6 8V16M18 8V16M8 18H16" />
  ),
  verified: (
    <path d="M20 7L9 18L4 13" />
  ),
  portfolio: (
    <path d="M4 9H20M9 9V7C9 5.9 9.9 5 11 5H13C14.1 5 15 5.9 15 7V9M6 19H18C19.1 19 20 18.1 20 17V9H4V17C4 18.1 4.9 19 6 19Z" />
  ),
  monitoring: (
    <path d="M4 18L9 13L12 16L20 8M4 6H20M4 10H8" />
  ),
  chatbot: (
    <path d="M8 10H16M8 14H12M20 11C20 15.42 16.42 19 12 19H9L5 21V11C5 6.58 8.58 3 13 3C17.42 3 20 6.58 20 11Z" />
  ),
  search: (
    <path d="M11 18C14.87 18 18 14.87 18 11C18 7.13 14.87 4 11 4C7.13 4 4 7.13 4 11C4 14.87 7.13 18 11 18ZM20 20L16 16" />
  ),
  workflow: (
    <path d="M6 7H11M13 7H18M6 12H9M11 12H16M6 17H13M15 17H18M4 5H6V7H4V5ZM11 10H13V12H11V10ZM18 15H20V17H18V15Z" />
  ),
  poc: (
    <path d="M12 3L19 7V12C19 16.42 16.11 20.37 12 21C7.89 20.37 5 16.42 5 12V7L12 3ZM10 12L11.5 13.5L14.5 10.5" />
  ),
  consulting: (
    <path d="M12 4C8.13 4 5 7.13 5 11C5 14.87 8.13 18 12 18C15.87 18 19 14.87 19 11C19 7.13 15.87 4 12 4ZM12 1V4M12 18V21M4.22 4.22L6.34 6.34M17.66 15.66L19.78 17.78M1 11H4M20 11H23" />
  ),
  audio: (
    <path d="M5 14H8L13 19V5L8 10H5V14ZM17 9C18.21 9.91 19 11.37 19 13C19 14.63 18.21 16.09 17 17" />
  ),
  recognition: (
    <path d="M8 4H5C4.45 4 4 4.45 4 5V8M16 4H19C19.55 4 20 4.45 20 5V8M8 20H5C4.45 20 4 19.55 4 19V16M16 20H19C19.55 20 20 19.55 20 19V16M9 15C9.8 15.62 10.85 16 12 16C13.15 16 14.2 15.62 15 15M9 10H9.01M15 10H15.01" />
  ),
};

export default function IconBadge({ name, className = '', size = 'md' }) {
  const icon = icons[name] || icons.portfolio;

  return (
    <span className={`icon-badge icon-badge-${size} ${className}`.trim()} aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" className="icon-badge-svg" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          {icon}
        </g>
      </svg>
    </span>
  );
}
